import axios from 'axios';

let _token = null;

export function setHttpToken(token) {
    _token = token;
}


axios.interceptors.request.use((config: any) => {
    if (config.url.includes('googleapis')) {
        // config.headers.Authorization = null;
        delete config.headers['Authorization'];
    }
    return config;
}, error => {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    if (_token) {
        // authenticated user
        config.headers = {
            ...config.headers,
            'Authorization': 'Bearer ' + _token
        };
    }
    
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


const httpClient = axios;

export default httpClient;